import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';

import { USStateAbbrevMap } from '@sondermind/utilities/states-list';

import { IState } from '../models/state';
import { StatesServedHttpService } from '../services/states-served.httpservice';

@Injectable({
  providedIn: 'root'
})
export class StatesServedStore {
  private states$!: Observable<IState[]>;

  constructor(
    private statesServedHttpService: StatesServedHttpService
  ){}

  stateList$(): Observable<IState[]> {
    if (!this.states$) {
      this.states$ = this.statesServedHttpService.listStates$().pipe(
        map((response) => {
          const states = response.data;
          states.sort((a, b) => a.localeCompare(b));
          return states.map((state) => ({
            abbreviation: state,
            name: this.getStateName(state)
          }));
        }),
        shareReplay({ bufferSize: 1, refCount: true })
      );
    }

    return this.states$;
  }

  private getStateName(stateAbbrev: string): string {
    if (stateAbbrev === 'DC') {
      return 'DC';
    }

    return USStateAbbrevMap[stateAbbrev] ?? stateAbbrev;
  }
}
